export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/bn.lyaml"));
at({ "bn": { "public": { "sampleString": "\u09A8\u09AE\u09C1\u09A8\u09BE \u09B8\u09CD\u099F\u09CD\u09B0\u09BF\u0982" } } });
};